import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
var CourseLearningHomeComponent = (function () {
    function CourseLearningHomeComponent(apiService, commonService, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.route = route;
        this.router = router;
        this.onLessonChosen = new EventEmitter();
        this.onExit = new EventEmitter();
        this.onQuestionChosen = new EventEmitter();
        this.onimage = new EventEmitter();
        this.assetsRoute = "../../assets";
    }
    CourseLearningHomeComponent.prototype.onWindowScroll = function (event) {
        var headWrapHeightMax = 1.6 * this.commonService.rootFontSize(), headWrapHeightMin = 0.8 * this.commonService.rootFontSize(), headWrap = document.getElementById("head_wrap"), headTitle = document.getElementById("title2");
        if (headWrap !== null && headTitle !== null) {
            if (window.pageYOffset > headWrapHeightMin) {
                headWrap.style.height = headWrapHeightMin + "px";
                headTitle.style.opacity = "1";
            }
            else if (window.pageYOffset == 0) {
                headTitle.style.opacity = "0";
                headWrap.style.height = headWrapHeightMax + "px";
            }
        }
    };
    ;
    CourseLearningHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        setTimeout(function () {
            _this.isShowLoadingComponent = true;
        }, 5000);
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        var that = this;
        this.courseNumber = this.course.lessons.length;
        this.userType = window.sessionStorage.getItem('userType');
        this.setFinishedNumber();
        this.test = false;
        this.lessons = this.course.lessons;
        // if(this.userType){
        //   // this.course.lessons
        //   this.course.lessons[0].status = 0;
        //   this.lessons = this.course.lessons;
        // }else{
        //   this.lessons = this.course.lessons;
        // }
        this.firstNoteShow = false;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            //alert('No.2!'+this.learningPathMetaId);
            _this.apiService.getOrCreateLearningPath(_this.learningPathMetaId).subscribe(function (result) {
                _this.learningPath = result;
                if (result.lock !== 2) {
                    _this.goPracticeFlag = true;
                }
                else {
                    _this.goPracticeFlag = false;
                }
                // console.log(this.learningPath);
            });
        });
        // 测试API
        if (this.course.name == '卓越辅导') {
            this.guideText = [{
                    position: 1,
                    text: '辅导前，先了解这些'
                }, {
                    position: 3,
                    text: '完美辅导，怎么做？'
                }, {
                    position: 8,
                    text: '学会这些，能力升级'
                }];
        }
        else if (this.course.name == '团队课程') {
            this.guideText = [{
                    position: 1,
                    text: '诊断：团队经典挑战'
                }, {
                    position: 3,
                    text: '打造：成功团队五因素'
                }, {
                    position: 9,
                    text: '打造：成功团队五因素'
                }];
        }
        else if (this.course.name == '授权课程') {
            this.guideText = [{
                    position: 1,
                    text: '授权经典挑战'
                }
            ];
        }
        else {
            this.guideText = [{
                    position: 1,
                    text: ''
                }];
        }
        // 获取串接词
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/concatenation/' + this.learningPathId,
            'data': {
                'learningPathId': this.learningPathId,
            }
        }).subscribe(function (comment) {
            comment.forEach(function (item, index) {
                if (item.title == '课程学习') {
                    that.chuanjie = item.comment;
                }
            });
        });
        this.guideTextAll = [];
        this.positionArray = [];
        this.guideText.forEach(function (item, index) {
            that.positionArray.push(item.position - 1);
        });
        var backgroundColorType = 0;
        this.lessons.forEach(function (item, index) {
            if (that.commonService.inArray(that.positionArray, index) && index != 0) {
                backgroundColorType = backgroundColorType == 0 ? 1 : 0;
            }
            item.backgroundColorType = backgroundColorType;
        });
        for (var i = 0; i < this.lessons.length; i++) {
            this.guideTextAll[i] = { position: -1, text: '' };
            for (var j = 0; j < this.guideText.length; j++) {
                if (this.guideText[j].position - 1 == i) {
                    this.guideTextAll[i] = this.guideText[j];
                }
            }
        }
        /*this.disableRoll();*/
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/getUserInfo',
            'data': {}
        }).subscribe(function (result) {
            _this.status = result;
        });
        /*this.status = 1;*/
        this.getMaskStatus();
        // this.disableRolling2();
        if (this.finishedNumber != this.lessons.length) {
            this.initScroll = setInterval(function () {
                if ($('.yellowCircle').length > 0) {
                    clearInterval(that.initScroll);
                    var top_1 = $('.yellowCircle').offset().top;
                    /* $(window).scrollTop(top-5*that.commonService.rootFontSize());*/
                    $('html, body').animate({
                        scrollTop: top_1 - 5 * that.commonService.rootFontSize()
                    });
                }
            }, 200);
        }
        // } else if(this.finishedNumber == this.lessons.length && !this.maskStatus && this.course.name = "沟通课程"){
        //
        //   // 提示已经完成课程
        //   $('#nextWrap').show();
        //   $("#nextWrap").animate({
        //       bottom: 0
        //   });
        //
        // }
    };
    CourseLearningHomeComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
        $('body').css("height", "auto");
    };
    CourseLearningHomeComponent.prototype.setFinishedNumber = function () {
        this.finishedNumber = 0;
        if (this.userType) {
            // this.finishedNumber = 0;
            for (var i = 0; i < this.course.lessons.length; i++) {
                var preLength = 0;
                if (this.course.lessons[i].questionsGroup) {
                    preLength = this.course.lessons[i].questionsGroup.filter(function (d) { return d.afterClass == 2; }).length;
                    this.course.lessons[i].preLength = preLength;
                }
                if (this.course.lessons[i].status == 2 && (!this.course.lessons[i].questionsGroup || this.course.lessons[i].questionsGroup && (this.course.lessons[i].speed == 2 || this.course.lessons[i].questionsGroup.length == preLength && this.course.lessons[i].speed == 0))) {
                    this.finishedNumber++;
                }
            }
        }
        else {
            for (var i = 0; i < this.course.lessons.length; i++) {
                var preLength = 0;
                if (this.course.lessons[i].questionsGroup) {
                    preLength = this.course.lessons[i].questionsGroup.filter(function (d) { return d.afterClass == 2; }).length;
                    this.course.lessons[i].preLength = preLength;
                }
                if (this.course.lessons[i].status == 2 && (!this.course.lessons[i].questionsGroup || this.course.lessons[i].questionsGroup && (this.course.lessons[i].speed == 2 || this.course.lessons[i].questionsGroup.length == preLength && this.course.lessons[i].speed == 0))) {
                    this.finishedNumber++;
                }
            }
            // console.log("Finished number is " + this.finishedNumber.toString());
        }
    };
    CourseLearningHomeComponent.prototype.getMaskStatus = function () {
        var _this = this;
        if (this.course.name == '卓越辅导') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/101',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '团队课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/111',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '授权课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/121',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '沟通课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/131',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/135',
                'data': {}
            }).subscribe(function (result) {
                _this.finishStatus = result == 1 ? true : false;
                console.log(_this.finishStatus);
                if (_this.finishStatus) {
                    $(document).ready(function () {
                        $("#nextWrap").show();
                        $("#nextWrap").animate({
                            bottom: 0
                        });
                    });
                }
            });
        }
        else if (this.course.name == '组织与计划课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/141',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '协作课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/151',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '影响力课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/161',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '影响力专业版课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/1611',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '决策课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/171',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '驱动变革课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/181',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '领导力启程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/191',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/195',
                'data': {}
            }).subscribe(function (result) {
                _this.finishStatus = result == 1 ? true : false;
                console.log(_this.finishStatus);
                if (_this.finishStatus) {
                    $(document).ready(function () {
                        $("#nextWrap").show();
                        $("#nextWrap").animate({
                            bottom: 0
                        });
                    });
                }
            });
        }
        else if (this.course.name == '达至最佳绩效课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/301',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '目标选才课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/311',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
        else if (this.course.name == '解决冲突课程') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/321',
                'data': {}
            }).subscribe(function (result) {
                _this.maskStatus = result == 1 ? false : true;
            });
        }
    };
    CourseLearningHomeComponent.prototype.getLesson = function (i, k) {
        // k is the video index
        // console.log(i+','+k);
        if (i <= this.finishedNumber && (!this.course.lessons[i].hasPreLesson || this.course.lessons[i].hasPreLesson &&
            (this.course.lessons[i].status == 2 || this.course.lessons[i].status == 4)) &&
            (!this.course.lessons[i].hasMultiLesson || this.course.lessons[i].hasMultiLesson &&
                (this.course.lessons[i].status >= 20 + k || this.course.lessons[i].status == 2 || this.course.lessons[i].status == 0 && k == 0)) &&
            (this.status == 1 || this.status != 1 && i <= 1)) {
            $('body').css("height", "100%");
            this.onLessonChosen.emit([i, k]);
        }
    };
    CourseLearningHomeComponent.prototype.getTip = function (i) {
        if (this.status != 1 && i > 1) {
            $("#shade2").fadeIn();
            $('#tip2').fadeIn();
        }
    };
    //精华笔记
    CourseLearningHomeComponent.prototype.goNote = function () {
        if (this.assetsRoute === 'assets') {
            var link = ["course-note", this.learningPathId, this.course.id, 0];
            this.router.navigate(link);
        }
        else {
            this.noteShow = true;
            setTimeout(function () {
                $('#closeBtnNote').show();
            }, 300);
        }
    };
    CourseLearningHomeComponent.prototype.getQuestion = function (i, j) {
        var preLength = this.course.lessons[i].questionsGroup.filter(function (d) { return d.afterClass == 2; }).length;
        if (i <= this.finishedNumber && (this.course.lessons[i].status == 2 || (this.course.lessons[i].hasPreLesson && j <= preLength - 1)) && (this.status == 1 || this.status != 1 && i <= 1)) {
            $('body').css("height", "100%");
            this.onQuestionChosen.emit([i, j]);
        }
    };
    CourseLearningHomeComponent.prototype.changzouwen = function () {
        //$('#biji1,#biji2').css({'display':'block'});
    };
    CourseLearningHomeComponent.prototype.closeBiji = function () {
        $('#biji1,#biji2').css({ 'display': 'none' });
    };
    // 关闭精华笔记
    CourseLearningHomeComponent.prototype.closeNote = function () {
        this.noteShow = false;
        $('#closeBtnNote').hide();
        // 如果第一次时候关闭，展示下一课的过渡
        // console.log(this.firstNoteShow);
        if (this.firstNoteShow) {
            // 只显示有情景模拟的
            if (this.course.name != "沟通课程" && this.course.name != "领导力启程" && this.course.name != "目标选才课程") {
                $("#shade").fadeIn();
                $("#guide").show();
                $("#guide").animate({
                    'top': '0.9rem'
                });
            }
            else if (this.course.name == "领导力启程") {
                // 提示已经完成课程
                $("#nextWrap").show();
                $("#nextWrap").animate({
                    bottom: 0
                });
                // 标记完成
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/195',
                    'data': {}
                }).subscribe(function (result) { });
            }
            else if (this.course.name == "沟通课程") {
                // 提示已经完成课程
                $("#nextWrap").show();
                $("#nextWrap").animate({
                    bottom: 0
                });
                // 标记完成
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/135',
                    'data': {}
                }).subscribe(function (result) { });
            }
            else if (this.course.name == "目标选才课程") {
                // 提示已经完成课程
                $("#nextWrap").show();
                $("#nextWrap").animate({
                    bottom: 0
                });
                // 标记完成
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/315',
                    'data': {}
                }).subscribe(function (result) { });
            }
            else if (this.course.name == "解决冲突课程") {
                // 提示已经完成课程
                $("#nextWrap").show();
                $("#nextWrap").animate({
                    bottom: 0
                });
                // 标记完成
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/325',
                    'data': {}
                }).subscribe(function (result) { });
            }
            else { }
        }
        // $('body').css("height", "auto");
    };
    CourseLearningHomeComponent.prototype.guideAnimateOut = function () {
        var _this = this;
        $('body').css("height", "100%");
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService.ajax({
                'type': 'GET',
                'url': '/sr/exposeoutapi/setAbilitySession/' + _this.learningPathMetaId + '/3'
            }).subscribe(function (result) { });
            //alert('No.2!'+this.learningPathMetaId);
            _this.apiService.getOrCreateLearningPath(_this.learningPathMetaId).subscribe(function (result) {
                _this.learningPath = result;
                // console.log(this.learningPath);
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/learningtour',
                }).subscribe(function (result) {
                    _this.learningTour = result.pre_survey_meta_ids.length > 0 ? true : false;
                    if (_this.learningTour) {
                        if (_this.learningPath.subItems.length == 2) {
                            _this.gotoPractice(1);
                        }
                        else {
                            _this.gotoPractice(2);
                        }
                    }
                    else {
                        if (_this.learningPath.subItems.length == 2) {
                            if (_this.learningPath.name == '领导力精要') {
                                var link = ['learning-path', _this.learningPathMetaId];
                                _this.router.navigate(link);
                            }
                        }
                        else if (_this.learningPath.subItems.length == 3 || (_this.learningPath.name == '辅导' && _this.learningPath.subItems.length == 4) || (_this.learningPath.name == '打造高效团队' && _this.learningPath.subItems.length == 4) || (_this.learningPath.name == '驱动变革' && _this.learningPath.subItems.length == 4) || (_this.learningPath.name == '达至最佳绩效' && _this.learningPath.subItems.length == 4) || (_this.learningPath.name == '解决冲突' && _this.learningPath.subItems.length == 4)) {
                            _this.gotoPractice(2);
                        }
                        else if (_this.learningPath.subItems.length >= 4) {
                            _this.gotoPractice(2);
                        }
                    }
                });
            });
        });
    };
    CourseLearningHomeComponent.prototype.gotoPractice = function (practiceIndex) {
        var practiceMetaId = this.learningPath.subItems[practiceIndex].practiceMetaId;
        console.log(practiceMetaId);
        //转向情景列表
        var link = this.abilityConfig.getPracticeLinkList(this.learningPath.name, this.learningPath.id, practiceMetaId);
        if (link.length > 0) {
            this.router.navigate(link);
        }
    };
    CourseLearningHomeComponent.prototype.finish = function () {
        var _this = this;
        if (this.finishStatus) {
            return;
        }
        else {
            var link_1;
            $('body').css("height", "100%");
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/learningtour',
            }).subscribe(function (result) {
                _this.learningTour = result.pre_survey_meta_ids.length > 0 ? true : false;
                if (_this.learningTour) {
                    link_1 = ['learning-map', 3];
                    _this.router.navigate(link_1);
                }
                else {
                    link_1 = ['learning-map'];
                    _this.router.navigate(link_1);
                }
            });
        }
    };
    CourseLearningHomeComponent.prototype.close = function () {
        this.setFinishedNumber();
        if (this.status == 1) {
            if (this.finishedNumber < this.courseNumber) {
                $("#shade").fadeIn(300);
                $("#tip1").fadeIn(300);
            }
            else {
                $('body').css("height", "100%");
                this.exit();
            }
        }
        else {
            if (this.finishedNumber <= 1) {
                $("#shade").fadeIn(300);
                $("#tip1").fadeIn(300);
            }
            else {
                $('body').css("height", "100%");
                this.exit();
            }
        }
    };
    CourseLearningHomeComponent.prototype.continue = function () {
        $("#tip1").fadeOut(300);
        $("#shade").fadeOut(300);
    };
    CourseLearningHomeComponent.prototype.exit = function () {
        $('body').css("height", "100%");
        if (this.initScroll) {
            clearInterval(this.initScroll);
        }
        this.onExit.emit(true);
    };
    CourseLearningHomeComponent.prototype.try = function () {
        $('body').css("height", "100%");
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    CourseLearningHomeComponent.prototype.shareHide = function () {
        $('#share').fadeOut();
        if (this.course.name == '卓越辅导') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/101',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '团队课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/111',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '授权课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/121',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '沟通课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/131',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '组织与计划课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/141',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '协作课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/151',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '影响力课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/161',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '影响力专业版课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/1610',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '决策课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/171',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '驱动变革课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/181',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '领导力启程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/191',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '达至最佳绩效课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/301',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '目标选才课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/311',
                'data': {}
            }).subscribe(function (result) { });
        }
        else if (this.course.name == '解决冲突课程') {
            this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/321',
                'data': {}
            }).subscribe(function (result) { });
        }
        else {
        }
        if (this.assetsRoute === 'assets') {
            var link = ["course-note", this.learningPathId, this.course.id, 1];
            this.router.navigate(link);
        }
        else {
            this.noteShow = true;
            setTimeout(function () {
                $('#closeBtnNote').show();
            }, 300);
            this.firstNoteShow = true;
        }
    };
    CourseLearningHomeComponent.prototype.hideTip2 = function () {
        $("#shade2").fadeOut();
        $('#tip2').fadeOut();
    };
    CourseLearningHomeComponent.prototype.disableRolling = function () {
        document.getElementById('shade').ontouchstart = function (e) { e.preventDefault(); };
        document.getElementById('tip1').ontouchstart = function (e) { e.preventDefault(); };
        document.getElementById('quitBtn').ontouchstart = function (e) { e.preventDefault(); };
        document.getElementById('continueBtn').ontouchstart = function (e) { e.preventDefault(); };
    };
    CourseLearningHomeComponent.prototype.disableRolling2 = function () {
        document.getElementById('shade2').ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById('tip2').ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById('tipBtn2').ontouchmove = function (e) { e.preventDefault(); };
    };
    CourseLearningHomeComponent.prototype.disableRoll = function () {
        document.getElementById('share').ontouchmove = function (e) { e.preventDefault(); };
    };
    CourseLearningHomeComponent.prototype.openPDF = function (number) {
        window.open("../../assets/pdf/jinghua11-" + number + ".pdf", "_blank");
    };
    return CourseLearningHomeComponent;
}());
export { CourseLearningHomeComponent };



// WEBPACK FOOTER //
// ./src/app/course-learning-home/course-learning-home.component.ts.pre-build-optimizer.js